import { useRef, useContext } from "react";
import SignatureCanvas from "react-signature-canvas";
import { GlobalState } from "./../../context/globalState";
import { Form, Input } from "antd";


const SignaturePad = ({ form }) => {
  const sigCanvas = useRef();
  const { isMobile } = useContext(GlobalState);

  const clear = () => {
    sigCanvas.current.clear();
    form.setFieldsValue({ signature: undefined });
  };

  const Save = () => {
    const image = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    const timeoutId = setTimeout(() => {
      urltoFile(image, 'signature.png')
        .then(function (file) {
          form.setFieldsValue({ signature: file });
        })
    }, 200);
    return () => clearTimeout(timeoutId);
  };

  const urltoFile = (url, filename, mimeType) => {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }

  return (
    <div style={{ textAlign: "left" }}>
      <div style={{ display: "flex", gap: 10, justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: isMobile ? 14 : 16, fontWeight: 600, color: '#343A40' }} >Chữ ký của bạn <sup style={{ color: 'red' }}>*</sup></div>
        <div style={{ fontSize: isMobile ? 14 : 16, fontWeight: 600, color: '#FB7800', cursor: 'pointer', textDecoration: 'underline' }} onClick={clear}>Ký lại</div>
      </div>
      <div
        style={{
          border: "1px solid #D2D2D2",
          borderRadius: isMobile ? 8 : 16,
          height: isMobile ? 155 : 155,
        }}
      >
        <SignatureCanvas
          minWidth={0.6}
          maxWidth={1.0}
          ref={sigCanvas}
          onEnd={() => Save()}
          penColor="black"
          backgroundColor="white"
          canvasProps={{ className: "sigCanvas" }}
        />
      </div>
      <Form.Item style={{ opacity: 0 }} name="signature" label="" rules={[{ required: true, message: 'Vui lòng ký tên để tiếp tục!' }]}>
        <Input
          allowClear
          type="text"
          placeholder="Link Chữ ký"
          disabled
        />
      </Form.Item>
    </div>
  );
};

export default SignaturePad;

